<template>
    <component
        :is="is.is"
        v-bind="is.bind"
    />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import type { Color, ContentComponentItemFragment } from '@/graphql/api'
import { assertNever } from '@/helpers'

import ContentButton, {
    type PageType,
} from '@/components/cms/component/content/ContentButton.vue'

// const ContentButton = defineAsyncComponent(
//     () => import('@/components/cms/component/content/ContentButton.vue')
// )
const ContentText = defineAsyncComponent(
    () => import('@/components/cms/component/content/ContentText.vue')
)
const ContentTitle = defineAsyncComponent(
    () => import('@/components/cms/component/content/ContentTitle.vue')
)

const DebugComponent = defineAsyncComponent(
    () => import('@/components/cms/component/DebugComponent.vue')
)

const ContentSpacer = defineAsyncComponent(
    () => import('@/components/cms/component/content/ContentSpacer.vue')
)

const ContentImage = defineAsyncComponent(
    () => import('@/components/cms/component/content/ContentImage.vue')
)

const ContentOrderedList = defineAsyncComponent(
    () => import('@/components/cms/component/content/ContentOrderedList.vue')
)
import { getComponent } from '@/types/vue.ts'

const {
    data,
    background = undefined,
    hasEagerImage,
    pageType,
} = defineProps<{
    data: ContentComponentItemFragment
    background?: Color
    hasEagerImage?: boolean
    pageType: PageType
}>()

const is = computed(() => {
    const type = data.__typename

    switch (type) {
        case 'ComponentButton':
            return getComponent(ContentButton, {
                pageType,
                data,
            })
        case 'ComponentText':
            return getComponent(ContentText, {
                background,
                data,
            })
        case 'ComponentTitle':
            return getComponent(ContentTitle, {
                data,
                background,
            })
        case 'ComponentSpacer':
            return getComponent(ContentSpacer, {
                data,
            })
        case 'ComponentImage':
            return getComponent(ContentImage, {
                data,
                hasEagerImage,
            })
        case 'ComponentOrderedList':
            return getComponent(ContentOrderedList, {
                data,
                background,
            })
        default:
            return assertNever(
                type,
                getComponent(DebugComponent, {
                    data,
                })
            )
    }
})
</script>
